export default "__VITE_ASSET__ea6f21a7__"